/**
 * Base controller module
 *
 * @module controllers/base/controller
 */
define('controllers/base/controller',['require','jquery','underscore','chaplin','mediator','views/site','views/messages','views/header','views/breadcrumb','views/sidebar','models/help','views/help','views/footer','views/poll','views/dialog','lib/utils'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        Chaplin = require('chaplin'),
        mediator = require('mediator'),

        SiteView = require('views/site'),
        MessagesView = require('views/messages'),
        HeaderView = require('views/header'),
        BreadcrumbView = require('views/breadcrumb'),
        SidebarView = require('views/sidebar'),
        HelpModel = require('models/help'),
        HelpView = require('views/help'),
        FooterView = require('views/footer'),
        PollView = require('views/poll'),
        Dialog = require('views/dialog'),
        utils = require('lib/utils');

    var Controller = Chaplin.Controller.extend({
        beforeAction: function(params, route) {
            var _this = this;
            var parentPage, parentName, page, item;

            if (mediator.applicationError && route.name !== 'errors#500') {
                return this.redirectTo('errors#500');
            }

            if (!mediator.isAuthorized()) {
                return this.redirectTo('auth#login');
            }

            var pages = mediator.pages;

            page = pages.findWhere({ action: route.name });

            if (page) {
                if (!mediator.user.hasRoles(page.get('roles'))){

                    Dialog.show('Ограничение доступа', 'Доступ закрыт.', Dialog.Buttons.Close);

                    if (route.previous.name) {
                        return this.redirectTo({ url: route.previous.path });
                    } else {
                        return this.redirectTo('dashboard#show');
                    }
                }
            }

            this.publishEvent('controller:actionStart');

            mediator.mainMenu.without(page).forEach(function(page) {
                page.set('active', false);
            });

            if (page) {
                page.set('params', params);

                parentName = page.get('parent');
                if (parentName) {
                    parentPage = pages.findWhere({ name: parentName });
                }

                if (parentPage) {
                    parentPage.set('active', true);
                } else {
                    page.set('active', true);
                }

                this.adjustTitle(page.get('title'));

                item = page.getAttributes();
                item.isLast = true;
                mediator.breadcrumb.set('items', [item]);
            }

            this.compose('site',         SiteView);
            this.compose('messages',     MessagesView);
            this.compose('header',       HeaderView);
            this.compose('breadcrumb',   BreadcrumbView,  { model: mediator.breadcrumb });
            this.compose('sidebar',      SidebarView,     { model: mediator.sidebar });
            this.compose('help',         HelpView,        { model: new HelpModel({ id: page ? page.getHelpId() : '' }) });
            this.compose('footer',       FooterView);
            this.compose('poll',         PollView,        { model: mediator.poll });

            this.subscribeEvent('dispatcher:dispatch', function() {
                if (!$.active) {
                    _this.afterAction();
                } else {
                    $(document).one('ajaxStop', function() {
                        _this.afterAction();
                    });
                }
            });
        },

        /**
         * Runs after action
         *
         * @method afterAction
         */
        afterAction: function() {
            this.publishEvent('controller:actionDone');
        },

        createSessionsNewForm: function() {

        }
    });

    return Controller;
});

